export default class Menu {
  constructor(node) {
    this.node = node

    this.button = this.node.querySelector('.menu-button')
    this.mainNav = this.node.querySelector('.main-nav')

    this.clickToggle = this.clickToggle.bind(this)

    this.init()
  }

  init() {
    console.debug('  -> Menu init')
    this.reset()
    this.addListeners()
  }

  addListeners() {
    this.button.addEventListener('click', this.clickToggle)
  }

  clickToggle(e) {
    e.preventDefault()
    this.button.classList.toggle('open')
    this.mainNav.classList.toggle('open')
    this.node.classList.toggle('no-shadow')
    document.querySelector('html').classList.toggle('h-noscroll')
  }

  reset() {
    console.debug('  -> Menu reset')
    this.button.classList.remove('open')
    this.mainNav.classList.remove('open')
    this.node.classList.remove('no-shadow')
    document.querySelector('html').classList.remove('h-noscroll')
  }

  static destroy() {
    console.debug('  -> Menu destroy')
  }

  static init() {
    console.debug('== Menu component ==')
    Menu.item = new Menu(document.querySelector('.header'))
  }
}
